import { render, staticRenderFns } from "./TrainingHubOverview.vue?vue&type=template&id=65870667&scoped=true"
import script from "./TrainingHubOverview.vue?vue&type=script&lang=js"
export * from "./TrainingHubOverview.vue?vue&type=script&lang=js"
import style0 from "./TrainingHubOverview.vue?vue&type=style&index=0&id=65870667&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65870667",
  null
  
)

export default component.exports